import React, { useEffect, useState } from "react";
import { Button, Modal, ProgressBar } from "react-bootstrap";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
import { BiUpload } from "react-icons/bi";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import { useDispatch } from "react-redux";
import { setReminder } from "../../features/UserActions";

export default function FileUploader(props) {
  const { showUpload, setShowUpload, selectedRow, userDetail } = props;
  const [files, setFiles] = useState();
  const [progress, setProgress] = useState({});

  // rerender files list
  useEffect(() => {
    if (files) {
      let array = [];
      for (let index = 0; index < files.length; index++) {
        array.push(0);
      }
      setProgress(array);
    }
    //console.log(files);
  }, [files]);

  // rerender progress bar
  useEffect(() => {}, [progress]);

  // clears files list when popup is visibled
  useEffect(() => {
    if (showUpload.show === false) {
      setFiles(null);
    }
  }, [showUpload?.show]);

  const dispatch = useDispatch();
  // update files when change files selection
  const handleChange = (e) => {
    for (const f of e.target.files) {
      if (f.size > 2000000) {
        dispatch(
          setReminder({
            show: true,
            message: "ขนาดไฟล์ได้ไม่เกิน 2 Mbyte",
            type: "error",
          })
        );
        return;
      }
    }

    setFiles(e.target.files);
  };

  // handle upload all files and progress bar
  const handleUpload = async (evt) => {
    const url = process.env.REACT_APP_API + "api/studyinfo/upload-file-blob";

    for (let i = 0; i < files.length; i++) {
      const f = files[i];
      const formData = new FormData();
      formData.append("user", JSON.stringify({ ...userDetail, uploadType: 1 })); // uploadType(1=file, 2=captured image, 3=scanned image)
      formData.append("rowdata", JSON.stringify(selectedRow));
      formData.append("file", f);

      let result = await axios.post(url, formData, {
        headers: {
          ...HttpJsonHeader,
          "Content-Type": "multipath/form-data",
        },
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
        timeout: 0,
        onUploadProgress: (evt) => {
          let numProgress = Math.round((100 * evt.loaded) / evt.total);
          for (let j = 0; j < progress.length; j++) {
            if (j === i) {
              progress[i] = numProgress;
            }
          }
          setProgress((p) => [...progress]);
        },
      });

      //debug
      if (result) {
        console.log("The file has been uploaded...");
      }
    }

    if (showUpload.action) {
      showUpload.action();
    }
  };

  const handleDragOver = async (evt) => {
    evt.preventDefault();
    // console.log(evt);
  };

  const handleDrop = async (evt) => {
    evt.preventDefault();

    if (evt.dataTransfer?.files[0].size > 2000000) {
      dispatch(
        setReminder({
          show: true,
          message: "ขนาดไฟล์ได้ไม่เกิน 2 Mbyte",
          type: "error",
        })
      );
      return;
    }

    let ff = [];
    if (files) {
      ff = files;
    }
    ff = [...ff, ...evt.dataTransfer.files];

    setFiles(ff);
  };

  // main rendering ...
  return (
    <MyModal
      show={showUpload?.show}
      onHide={() => setShowUpload({ show: false })}
      backdrop={false}
      centered
      size="lg"
    >
      <ModalHeaderBlack closeButton>
        {" "}
        <div style={{ flex: "1", color: "green", textAlign: "center" }}>
          Upload ไฟล์
        </div>
      </ModalHeaderBlack>
      <ModalBodyBlack>
        <div style={styles.body}>
          {/* <label htmlFor="fileupload">เลือกไฟล์</label> */}
          <input
            id="fileupload"
            className="file-uploader"
            type="file"
            multiple
            onChange={handleChange}
            title="เลือกไฟล์"
            style={{
              background: "#121212",
              color: "#5967e0",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          />
          <div style={styles.filelistHeader}>รายชื่อไฟล์ทั้งหมด</div>
          <div
            style={{
              background: "#111111",
              border: "1px solid #121212",
              padding: "15px",
              flex: "1",
            }}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            {files ? (
              Object.entries(files).map((e, i) => (
                <div style={styles.filelistStyle}>
                  <span style={{ color: "yellow" }}>{i + 1 + ". "} </span>
                  <span>{e[1].name}</span>
                  <span>
                    <ProgressBar variant="info" now={progress[i]} />
                  </span>
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              padding: "10px 0px 0 0px",
            }}
          >
            {files ? (
              <Button onClick={handleUpload}>
                <BiUpload style={{ marginInline: "10px", color: "#ebe70a" }} />
                เริ่ม Upload File
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </ModalBodyBlack>
    </MyModal>
  );
}

const styles = {
  body: {
    minHeight: "400px",
    padding: "20px 20px 20px 20px",
    display: "flex",
    flexDirection: "column",
  },

  filelistHeader: {
    textAlign: "center",
    color: "#4edd3b",
    padding: "10px 0 0 0",
  },

  filelistStyle: {
    color: "#e2f1f1",
  },
};
